// extracted by mini-css-extract-plugin
module.exports = {"TooltipTheme__tooltip-wrap__1hf_3":"TooltipTheme__tooltip-wrap__1hf_3","TooltipTheme__tooltip-position-right__1a4i9":"TooltipTheme__tooltip-position-right__1a4i9"};